module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/security/role/role.component.html
// module id = ./src/app/security/role/role.component.html
// module chunks = main